import { render, staticRenderFns } from "./NodeAccordion.vue?vue&type=template&id=db87a52e&"
import script from "./NodeAccordion.vue?vue&type=script&lang=js&"
export * from "./NodeAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports